import UserEvent from "../types/UserEvent";
import getDateKey from "../utils/getDateKey";
import getUserEvents from "./getUserEvents";

export default async function addUserEvent(
  userEvent: UserEvent,
  userId: string
) {
  const userEvents = (await getUserEvents(userEvent.date, userId)) ?? [];
  userEvents.push(userEvent);

  const dateKey = getDateKey(userEvent.date);

  localStorage.setItem(
    `${dateKey}-${userId}-userEvents`,
    JSON.stringify(userEvents)
  );

  return userEvents;
}
